// extracted by mini-css-extract-plugin
export default {"button":"Button_button__jEIJC","noDesign":"Button_noDesign__99ico","backButton":"Button_backButton__GFe2U"};